var React = require('react');

function SmsDont (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.584 20.001L4 18.415l2.452-2.452H5a1 1 0 01-.993-.883L4 14.964V6a1 1 0 01.883-.993L5 5l12.416-.001 2-1.999L21 4.586l-1.063 1.065a.994.994 0 01.055.232L20 6v8.964a1 1 0 01-.883.993l-.117.007h-2.216l.056 1.921a.5.5 0 01-.721.463l-.077-.047-3.145-2.337-3.274-.001-4.039 4.038zM7.716 9a1.271 1.271 0 100 2.542 1.271 1.271 0 000-2.542zm8.842.03l-1.516 1.515a1.272 1.272 0 101.516-1.515zm-5.424.31a1.271 1.271 0 00.043 1.9l1.792-1.792-.038-.043a1.271 1.271 0 00-1.797-.064z","fill":"currentColor","fillRule":"evenodd"}));
}

SmsDont.defaultProps = {"width":"25","height":"25"};

module.exports = SmsDont;

SmsDont.default = SmsDont;
